import { FormStore } from '@roc/feature-app-core';
import { action, makeObservable } from 'mobx';

const form = {
  fields: {
    pointOfContactId: {
      value: '',
      error: null,
      rule: '',
    },
    addPointOfContact: {
      value: 'Y',
      error: null,
      rule: 'required',
    },
    firstName: {
      value: '',
      error: null,
      rule: [{ required_if: ['addPointOfContact', 'Y'] }],
      message: 'First Name is a required field.',
    },
    lastName: {
      value: '',
      error: null,
      rule: [{ required_if: ['addPointOfContact', 'Y'] }],
      message: 'Last Name is a required field.',
    },
    phoneNumber: {
      value: '',
      error: null,
      rule: [{ required_if: ['addPointOfContact', 'Y'] }],
      message: 'Phone Number is a required field.',
    },
    drawSubType: {
      value: 'hard & soft costs',
      error: null,
      rule: 'required',
      message: 'Draw is a required field.',
    },
    email: {
      value: '',
      error: null,
      rule: [
        { required_if_email_format: ['addPointOfContact', 'Y', 'true', 'Yes'] }
      ],
      message: 'Email is a required field.',
    },
    comments: {
      value: '',
      error: null,
    },
    inspectionProcess: {
      value: '',
      error: null,
      rule: [{ required_if_one_of: ['drawSubType', 'hard & soft costs', 'hard costs'] }],
      message: 'Inspection process is a required field.',
    },
    property: {
      value: '',
      error: null,
      rule: 'required',
      message: 'Property is a required field.',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class PointOfContactFormStore extends FormStore {
  constructor(globalStore) {
    super({ ...form }, globalStore);
  }

  resetStore() {
    this.reset();
    this.form.fields.firstName.value = '';
    this.form.fields.lastName.value = '';
    this.form.fields.email.value = '';
    this.form.fields.phoneNumber.value = '';
    this.form.fields.comments.value = '';
    this.form.fields.inspectionProcess.value = '';
    this.form.fields.property.value = '';
  }
}
